<div class="col-xs-12 col-sm-12 col-lg-12 col-md-12 mt-1 p-1">
	<h5 class="text-blue">Select Student</h5>
	<div class="dropdown" style="width: 100%">
		<button id="btnGroupDrop1" type="button" class="btn btn-lg btn-primary dropdown-toggle" data-bs-toggle="dropdown" style="width: 100%" ng-click="initStuFinder();">
			<i class="fa fa-chevron-down float-right" style="font-size: 30px"></i>
			<div *ngIf="activeStudent" style="text-align: left" class="text-truncate">
				{{ activeStudent?.fname }}
				{{ activeStudent?.lname }}
			</div>
			<div *ngIf="!activeStudent" style="text-align: left" class="text-truncate">No students available</div>
		</button>
		<div style="width: 100%" class="dropdown-menu studentsList">
			<input class="student-searcher" [(ngModel)]="query" type="text" placeholder="Search.." />
			<div (click)="setStudent(s)" class="dropdown-item" *ngFor="let s of students | search : 'fname,lname' : query" [class.active-menu-item]="activeStudent === s">
				<div class="text-truncate">{{ s.fname }} {{ s.lname }}</div>
				<div class="text-muted" style="font-size: 12px">DOB: {{ s.dob }}</div>
			</div>
		</div>
	</div>
</div>
